/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalMCPTaskCreateRequest
 */
export interface InternalMCPTaskCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    ownerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    ownerClientId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    parametersSchemaVersion: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskCreateRequest
     */
    parameters: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskCreateRequest
     */
    ttlMs?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskCreateRequest
     */
    pollIntervalMs: number;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    statusMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    linkedResourceType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskCreateRequest
     */
    linkedResourceId?: string | null;
}

/**
 * Check if a given object implements the InternalMCPTaskCreateRequest interface.
 */
export function instanceOfInternalMCPTaskCreateRequest(value: object): value is InternalMCPTaskCreateRequest {
    if (!('ownerUserId' in value) || value['ownerUserId'] === undefined) return false;
    if (!('ownerClientId' in value) || value['ownerClientId'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('parametersSchemaVersion' in value) || value['parametersSchemaVersion'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('pollIntervalMs' in value) || value['pollIntervalMs'] === undefined) return false;
    return true;
}

export function InternalMCPTaskCreateRequestFromJSON(json: any): InternalMCPTaskCreateRequest {
    return InternalMCPTaskCreateRequestFromJSONTyped(json, false);
}

export function InternalMCPTaskCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ownerUserId': json['owner_user_id'],
        'ownerClientId': json['owner_client_id'],
        'kind': json['kind'],
        'parametersSchemaVersion': json['parameters_schema_version'],
        'parameters': json['parameters'],
        'ttlMs': json['ttl_ms'] == null ? undefined : json['ttl_ms'],
        'pollIntervalMs': json['poll_interval_ms'],
        'statusMessage': json['status_message'] == null ? undefined : json['status_message'],
        'linkedResourceType': json['linked_resource_type'] == null ? undefined : json['linked_resource_type'],
        'linkedResourceId': json['linked_resource_id'] == null ? undefined : json['linked_resource_id'],
    };
}

export function InternalMCPTaskCreateRequestToJSON(json: any): InternalMCPTaskCreateRequest {
    return InternalMCPTaskCreateRequestToJSONTyped(json, false);
}

export function InternalMCPTaskCreateRequestToJSONTyped(value?: InternalMCPTaskCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['ownerUserId'],
        'owner_client_id': value['ownerClientId'],
        'kind': value['kind'],
        'parameters_schema_version': value['parametersSchemaVersion'],
        'parameters': value['parameters'],
        'ttl_ms': value['ttlMs'],
        'poll_interval_ms': value['pollIntervalMs'],
        'status_message': value['statusMessage'],
        'linked_resource_type': value['linkedResourceType'],
        'linked_resource_id': value['linkedResourceId'],
    };
}

